const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const QuickSearch = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domSearchBtn: $('.js-search-init'),
	$domSearchOuter: $('.js-search-outer'),
	$domSearchInner: $('.js-search-inner'),
	$domSearchInput: $('.js-search-input'),
	$domSearchResults: $('.js-quick-search'),
	$domClearButton: $('.js-search-field-empty'), // on the search page
	$domSearchPageInput: $('.js-search-field'), // on the search page
	//
	$domQSproductResults: null,
	$domQSproductCount: null,
	$domQSmarketResults: null,
	$domQSmarketsCount: null,
	$domQSresourceResults: null,
	$domQSresourcesCount: null,
	$domLoader: null,
	$domNoResultsParent: null,
	$domNoResults: null,
	classActive: 'is-active',
	timeout: null,
	timer: null,
	allowEvents: true,

	/** @description Initialize */
	init: function() {
		this.initValues();
		this.bindEvents();
	},

	initValues: ()=> {
		// products
		QuickSearch.$domQSproductResults = $('.js-qs-product-results');
		QuickSearch.$domQSproductCount = $('.js-qs-products-count');
		// markets
		QuickSearch.$domQSmarketResults = $('.js-qs-market-results');
		QuickSearch.$domQSmarketsCount = $('.js-qs-markets-count');
		// resources
		QuickSearch.$domQSresourceResults = $('.js-qs-resource-results');
		QuickSearch.$domQSresourcesCount = $('.js-qs-resources-count');
		// other data
		QuickSearch.$domLoader = $('.js-qs-loader');
		QuickSearch.$domNoResultsParent = $('.js-qs-no-results-parent');
		QuickSearch.$domNoResults = $('.js-qs-no-results');
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domSearchBtn.on('click', this.toggleSearch.bind(this));
		Global.$domBody.on('mouseup', this.handleOutsideClick.bind(this));
		Global.escKey(this.closeSearch.bind(this));
		this.$domSearchInput.on('input', this.handleInputChange.bind(this));
		this.$domClearButton.on('click', this.clearField.bind(this));
		//
		QuickSearch.$domSearchInput.on('keypress', (event) => {
			QuickSearch.pressEnter(event);
		});
	},

	// reload page after press enter
	pressEnter: (event) => {
		const searchValue = QuickSearch.$domSearchInput.val().trim();
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault();
			if (searchValue.length >= 3) {
				const link = window.fwsLocalized.siteUrl + '?s=' + encodeURIComponent(searchValue);
				window.location.replace(link);
			}
		}
	},

	toggleSearch: function() {
		if (this.$domSearchOuter.hasClass(this.classActive)) {
			this.closeSearch();
		} else {
			this.openSearch();
		}
	},

	openSearch: function() {
		QuickSearch.emptyBlocks();
		QuickSearch.showNoResults(false);
		this.$domSearchBtn.addClass(this.classActive);
		this.$domSearchOuter.addClass(this.classActive);
		setTimeout(() => {
			this.$domSearchInput.focus(); // Ensure focus after DOM updates
		}, 250);
	},

	handleOutsideClick: function(e) {
		if (!this.$domSearchInner.is(e.target) && this.$domSearchInner.has(e.target).length === 0 && !this.$domSearchBtn.has(e.target).length) {
			this.closeSearch();
		}
	},

	// schedule ajax request
	enqueueAjax: function() {
		if (QuickSearch.allowEvents) {
			QuickSearch.dequeueAjax();
			this.$domSearchResults.addClass(this.classActive);
			QuickSearch.timer = setTimeout(QuickSearch.sendRequest, 600);
		}
	},

	// un-schedule ajax request
	dequeueAjax: function() {
		if (QuickSearch.timer) {
			clearTimeout(QuickSearch.timer);
			QuickSearch.timer = null;
		}
	},

	handleInputChange: function() {
		const inputValue = this.$domSearchInput.val().trim();
		if (inputValue.length >= 3) {
			QuickSearch.enqueueAjax();
		} else {
			QuickSearch.dequeueAjax();
			this.$domSearchResults.removeClass(this.classActive);
		}
	},

	closeSearch: function() {
		this.$domSearchBtn.removeClass(this.classActive);
		this.$domSearchOuter.removeClass(this.classActive);
		this.$domSearchResults.removeClass(this.classActive);
		this.$domSearchInput.val('');
	},

	clearField: function() {
		this.$domSearchPageInput.val(''); // Clear the value of the input field
		this.$domSearchPageInput.focus(); // Optionally focus the input field after clearing
	},


	sendRequest: () => {
		if (!QuickSearch.allowEvents) return;
		//
		QuickSearch.dequeueAjax();
		QuickSearch.emptyBlocks();
		QuickSearch.showNoResults(false);
		QuickSearch.showLoader(true);

		// send ajax
		$.ajax({
			url: window.fwsLocalized.ajaxUrl + '?_=' + new Date().getTime(),
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'quick-search',
				search: QuickSearch.$domSearchInput.val().trim(),
			},
			success: (response) => {
				QuickSearch.onAjaxSuccess(response.data);
			},
			complete: ()=>{
				QuickSearch.showLoader(false);
			},
		});
	},

	onAjaxSuccess: (data)=> {
		if (
			data.products.data.length === 0 &&
			data.markets.data.length === 0 &&
			data.resources.data.length === 0
		) {
			QuickSearch.showNoResults(true);
		} else {
			// products
			QuickSearch.$domQSproductCount.text(`(${data.products.count})`);
			QuickSearch.appendPosts(
				data.products.data,
				QuickSearch.$domQSproductResults,
				QuickSearch.productTemplate
			);
			// markets
			QuickSearch.$domQSmarketsCount.text(`(${data.markets.count})`);
			QuickSearch.appendPosts(
				data.markets.data,
				QuickSearch.$domQSmarketResults,
				QuickSearch.marketTemplate
			);
			// resources
			QuickSearch.$domQSresourcesCount.text(`(${data.resources.count})`);
			QuickSearch.appendPosts(
				data.resources.data,
				QuickSearch.$domQSresourceResults,
				QuickSearch.resourcesTemplate
			);
		}
	},

	appendPosts: (posts, block, template)=> {
		block.empty();
		// append
		for (let i = 0; i < posts.length; i++) {
			block.append(template(posts[i]));
		}
	},

	productTemplate: (post)=> {
		return `<li class="quick-search__product">
					<a class="quick-search__product-link" href="${post.permalink}">
						<h3 class="quick-search__product-title">${post.title}</h3>
						<ul lass="quick-search__product-list">
							${post.productType && post.typeImage ? `<li class="quick-search__product-list-item">
								<img class="quick-search__product-list-item-img" src="${post.typeImage}" alt="type-image">
								<div class="quick-search__product-list-item-val">${post.productType}</div>
							</li>` : ''}
							${post.mcuImage && post.mcu ? `<li class="quick-search__product-list-item">
								<img class="quick-search__product-list-item-img" src="${post.mcuImage}" alt="mcu-image">
								<div class="quick-search__product-list-item-val">${post.mcu}</div>
							</li>` : ''}
						</ul>
					</a>
				</li>`;
	},

	marketTemplate: (post)=> {
		return `<li class="quick-search__segment">
					<a class="quick-search__segment-link" href="${post.permalink}">
						<img class="quick-search__segment-img" src="${post.image}" alt="${post.title}">
						<p class="quick-search__segment-title">${post.title}</p>
					</a>
				</li>`;
	},

	resourcesTemplate: (post)=> {
		return `<li class="quick-search__article">
					<a class="quick-search__article-link" target="${post.target}" href="${post.permalink}">
						<img class="quick-search__article-img" src="${post.image}" alt="${post.title}">
						<div class="quick-search__article-details">
							<h3 class="quick-search__article-title">${post.title}</h3>
							<p class="quick-search__article-location">${post.location}</p>
						</div>
					</a>
				</li>`;
	},

	emptyBlocks: ()=> {
		// products
		QuickSearch.$domQSproductCount.text('(0)');
		QuickSearch.$domQSproductResults.empty();
		// markets
		QuickSearch.$domQSmarketsCount.text('(0)');
		QuickSearch.$domQSmarketResults.empty();
		// resources
		QuickSearch.$domQSresourcesCount.text('(0)');
		QuickSearch.$domQSresourceResults.empty();
	},

	showLoader: (active)=> {
		QuickSearch.$domLoader.toggleClass('is-visible', active);
	},

	showNoResults: (active)=> {
		QuickSearch.$domNoResultsParent.toggleClass('is-hidden', active);
		QuickSearch.$domNoResults.toggleClass('is-visible', active);
	},
};

export default QuickSearch;
